export default __webpack_public_path__ + "static/media/download.4d4832f6.svg";